/**
 * Уведомление врачу — окно подтверждения.
 *
 * Само окно общее (`MailComposeDialog`): счёт клинике подтверждается таким же.
 * Здесь остаётся только то, что своё, — заголовок и обращение к серверу.
 */

import type { ComposedLetter, LetterKind } from '@otc/shared';
import { api } from '../api/client.js';
import { MailComposeDialog } from './MailComposeDialog.js';

const TITLES: Record<LetterKind, string> = {
  ACCEPTED: 'Сообщить врачу, что заказ принят?',
  READY: 'Сообщить врачу, что заказ готов?',
};

export function SendLetterDialog({
  orderId,
  kind,
  doctorName,
  toEmail,
  letter,
  onDone,
  onSkip,
}: {
  orderId: string;
  kind: LetterKind;
  doctorName: string;
  toEmail: string;
  letter: ComposedLetter;
  /** Письмо ушло — здесь стоит обновить список и сказать об этом. */
  onDone: (sentTo: string) => void;
  /** Отказались отправлять или закрыли окно. */
  onSkip: () => void;
}) {
  return (
    <MailComposeDialog
      title={TITLES[kind]}
      recipientName={doctorName}
      toEmail={toEmail}
      letter={letter}
      note="Правка здесь на шаблон не влияет — шаблоны в разделе «Документы»."
      onCancel={onSkip}
      onSend={async ({ subject, body, toEmail }) => {
        const result = await api.post<{ sentTo: string }>(`/api/orders/${orderId}/letter`, {
          kind,
          toEmail,
          subject,
          body,
        });
        onDone(result.sentTo);
      }}
    />
  );
}
